import { HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { HttpService } from './http.service';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BinaryHttpRepository {
  private readonly apiService = inject(ApiService);
  private readonly httpService = inject(HttpService);

  public fetchInternalBlob(endpoint: string): Promise<HttpResponse<Blob>> {
    return firstValueFrom(
      this.apiService.get(endpoint, {
        responseType: 'blob' as 'json',
        observe: 'response' as 'body',
      }) as unknown as Observable<HttpResponse<Blob>>,
    );
  }

  public fetchExternalBlob(endpoint: string): Promise<HttpResponse<Blob>> {
    return firstValueFrom(this.httpService.get(endpoint) as unknown as Observable<HttpResponse<Blob>>);
  }
}
